import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">焦点专题</h2>
          <div className="w-12 h-1 bg-accent-500 mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.slice(0, 3).map((item) => (
            <a key={item.id} href="#" className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer">
              <div className="relative h-52 overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">{item.tag}</span>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-background-50 text-sm font-semibold leading-snug">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {carouselData.slice(3).map((item) => (
            <a key={item.id} href="#" className="group flex flex-col sm:flex-row bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer">
              <div className="relative sm:w-56 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">{item.tag}</span>
              </div>
              <div className="p-4 flex flex-col justify-center">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}